export const EMPLOYEE_ROLES = {
  PROJECT_MANAGER: 'Project Manager',
  PRINTER: 'Printer',
  SHIPPING: 'Shipping/Receiving',
  SCREENS: 'Screens/Ink'
}; 